import type { DominoRuleSet } from '../game/variants/types.js';
import { Evaluator } from './Evaluator.js';
import { KozyolEvaluator } from './KozyolEvaluator.js';
import type { MoveScorer } from './types.js';

/** The play evaluator matching the variant's scoring: fives or penalty (Козёл). */
export function scorerFor(ruleSet: DominoRuleSet): MoveScorer {
  return ruleSet.scoring === 'penalty' ? new KozyolEvaluator(ruleSet) : new Evaluator(ruleSet);
}
